/** Calendar-date math for the dry-cleaning return. Matches scheduling.dry_clean_return_date. */

const WEEKDAYS = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

function addDays(yyyyMmDd, days) {
    const [year, month, day] = yyyyMmDd.split("-").map(Number);
    const next = new Date(Date.UTC(year, month - 1, day + days));
    return next.toISOString().slice(0, 10);
}

function weekdayName(yyyyMmDd) {
    const [year, month, day] = yyyyMmDd.split("-").map(Number);
    return WEEKDAYS[new Date(Date.UTC(year, month - 1, day)).getUTCDay()];
}

/**
 * Earliest dry-cleaning return.
 * acceptDays empty: the cleaner receives the pieces on the pickup day.
 * Otherwise the next accept day on or after pickup, then turnaroundDays,
 * then the next day the shop delivers (closures always skipped).
 */
export function dryCleanReturnDate({
    pickup,
    acceptDays = [],
    turnaroundDays = 4,
    deliveryDays = [],
    closureDates = [],
    timeSelectionOn = true,
}) {
    if (!pickup) return "";
    const accept = new Set((acceptDays || []).map((day) => String(day).trim().toLowerCase()).filter(Boolean));
    let handoff = pickup;
    if (accept.size > 0) {
        for (let i = 0; i <= 14; i += 1) {
            const candidate = addDays(pickup, i);
            if (accept.has(weekdayName(candidate).toLowerCase())) {
                handoff = candidate;
                break;
            }
        }
    }
    const days = Number.isFinite(Number(turnaroundDays)) ? Math.max(0, parseInt(turnaroundDays, 10)) : 4;
    let raw = addDays(handoff, days);
    const closed = new Set((closureDates || []).map((d) => String(d || "").trim()).filter(Boolean));
    const delivery = new Set((deliveryDays || []).map((d) => String(d).trim().toLowerCase()).filter(Boolean));
    for (let i = 0; i <= 14; i += 1) {
        const candidate = addDays(raw, i);
        const dayOk = !timeSelectionOn || delivery.size === 0 || delivery.has(weekdayName(candidate).toLowerCase());
        if (!closed.has(candidate) && dayOk) return candidate;
    }
    return raw;
}
